export const isBillingAvailable = (service_name, supported_service_configs) => {
  const service = supported_service_configs.find(item => item.service === service_name)
  return service && service.config_params && service.config_params.visible_to_service && service.config_params.visible_to_service.includes('openstack_billing') ? true : false
}

export const getAllowedRoles = (service_name, supported_service_configs) => {
  const service = supported_service_configs.find(item => item.service === service_name)
  return (service && service.config_params && service.config_params.allowed_roles) ? service.config_params.allowed_roles : []
}